import { gql } from '@apollo/client';

export const postProvinciaIntegra = gql`
mutation ProvinciaIntegraRS{
    ProvinciaIntegraRS(input: $input)  
        @rest(type: "ProvinciaIntegraRS", path: "/api/gateway/formularios/FormularioProvinciaIntegra", method: "POST"){
            nroSolicitud
            nroSecuencia
            resultado
            error
            stackTrace
        }
}
`

